<template>
    <div class="template-generator-date">
        {{today}}
    </div>
</template>

<script>
import moment from 'moment'
export default {
    computed:{
        today(){
            if(this.date == "{{today}}") return moment().locale('tr').format("L")
            else return this.date
        }
    },
    props:{
        date:{
            type:String,
            default:""
        }
    }
}
</script>

<style>
.template-generator-date{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}
</style>